<template>
    <div class="row bg-white border-bottom px-3 py-2">
        <div class="col">
            <AppDropdown
                id="add-action"
                :data="Object.values(formElements)"
                @select="onAdd"
                :search="{ show: true, property: 'label', caseSensitive: false }">
                <span slot="menu-button" class="plus-btn">
                    <i class="fal fa-plus"></i>
                    Add
                </span>
                <template #item="{ item }">
                    <div class="media font-16 clickable">
                        <span class="font-14 text-muted text-center mr-2" style="width: 20px">
                            <i :class="item.icon"></i>
                        </span>
                        <div class="media-body">
                            {{ item.label }}
                        </div>
                    </div>
                </template>
            </AppDropdown>

        </div>
        <div class="col text-right align-self-center text-purple">
            <div @click="$emit('expand')" key="expand" class="d-inline clickable mr-3">
                <i class="fal fa-expand-alt"></i>
            </div>
            <div @click="$emit('collapse')" key="collapse" class="d-inline clickable">
                <i class="fal fa-compress-alt"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormCatalogToolbar',
    data() {
        return {
            formElements: {
                section: {
                    key: 'section',
                    label: 'Section',
                    icon: 'fal fa-receipt'
                },
                field: {
                    key: 'field',
                    label: 'Field',
                    icon: 'fal fa-rectangle-wide'
                }
            }
        }
    },
    methods: {
        onAdd(element) {
            if (element.key === this.formElements.section.key) {
                this.$modal.show('add-form-section')
            } else if (element.key === this.formElements.field.key) {
                this.$modal.show('add-form-field')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .plus-btn {
        font-size: 14px;
        color: white;
        border: 1px solid $color-purple-light;
        border-radius: 3px;
        padding: 2px 6px;
        background: $color-purple-light;

        &:hover {
            cursor: pointer;
        }
    }
</style>
